<template>
  <div>
    <div class="page-content">
      <Form
        ref="form"
        :model="form.params"
        class="form-box"
      >
        <div
          class="left-form"
          :style="{'minHeight': contentheight}"
        >
          <div
            v-for="(item,index) in skuInfo.productPropertyList"
            :key="index"
          >
            <div
              v-if="item.propertyName==='版本'"
            >
              <div class="form-section">
                <span class="form-section-name">订购服务</span>
                <span
                  v-if="orderType===1"
                  class="form-section-tip"
                >
                  我有激活码，我要兑换服务
                  <span
                    class="exhcnge-btn"
                    @click="goExchange"
                  >去兑换</span>
                </span>
              </div>
              <div
                v-for="(sitem,sindex) in item.propertyList"
                :key="sindex"
                :class="['version-item',{select:sindex===item.select}]"
                @click="skuSelect(index,sindex)"
              >
                <span class="version-name">{{ sitem.value }}</span>
                <span
                  v-if="orderedSku.versionLevel"
                  class="version-type"
                >
                  <span
                    v-if="sitem.versionLevel>orderedSku.versionLevel"
                    class="version-type-text version-type-text1"
                  >升级</span>
                  <span
                    v-else
                    class="version-type-text version-type-text2"
                  >续费</span>
                </span>
                <img
                  :src="sitem.versionLogo"
                  alt=""
                  style="height: 28px;"
                >
              </div>
            </div>
            <div
              v-else-if="item.propertyName==='服务周期'"
            >
              <div class="form-section">
                <span class="form-section-name">服务周期</span>
              </div>
              <div class="sku-section">
                <div
                  v-for="(sitem,sindex) in item.propertyList"
                  :key="sindex"
                  :class="['sku-item',{select:sindex===item.select}]"
                  @click="skuSelect(index,sindex)"
                >
                  <span class="sku-item-radio"></span>
                  <div class="sku-item-value">
                    {{ sitem.value }}{{ sitem.unit }}
                  </div>
                  <div class="sku-item-price">
                    <!-- 版本和服务周期存在时 -->
                    <div v-if="selectSkuItem.propertyValues['版本']">
                      <span>￥{{ versionPriceObj[selectSkuItem.propertyValues['版本']][sitem.value+sitem.unit].salePrice | moneyFix }}</span>
                    </div>
                    <div v-else>
                      <span>￥{{ versionPriceObj[sitem.value+sitem.unit].salePrice | moneyFix }}</span>
                    </div>
                  </div>
                  <div class="economize-amount">
                    <span v-if="selectSkuItem.propertyValues['版本']">
                      <template v-if="versionPriceObj[selectSkuItem.propertyValues['版本']][sitem.value+sitem.unit].economizeAmount!== null">
                        节省￥{{ versionPriceObj[selectSkuItem.propertyValues['版本']][sitem.value+sitem.unit].economizeAmount | moneyFix }}
                      </template>
                    </span>
                    <span v-else>
                      <template v-if="versionPriceObj[sitem.value+sitem.unit].economizeAmount">
                        节省￥{{ versionPriceObj[sitem.value+sitem.unit].economizeAmount | moneyFix }}
                      </template>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else-if="item.propertyName==='店铺数量'"
            >
              <div class="form-section">
                <span class="form-section-name">门店数量</span>
                <div
                  v-if="versionShopNum>0"
                  class="form-section-tip"
                >
                  <Icon
                    type="md-checkmark-circle"
                    size="16"
                    color="#ccc"
                    style="vertical-align: middle;"
                  />
                  <span style="vertical-align: middle; display: inline-block;">当前版本已包含{{ versionShopNum }}个店铺</span>
                </div>
              </div>
              <FormItem
                prop="shopNum"
                :rules="form.rules.shopNum"
              >
                <div class="shopNum-box">
                  <Input
                    v-model="form.params.shopNum"
                    class="input-shopNum"
                    placeholder="请输入个数"
                    :disabled="orderType===3"
                    clearable
                  ></Input>
                  <span
                    class="shopNum-unit"
                  >
                    <!-- {{ versionPriceObj[selectSkuItem.propertyValues['版本']][selectSkuItem.propertyValues['服务周期']] | moneyFix }}
                  {{ shopNum.propertyList[shopNum.select].unit }} -->
                    {{ shopNum.propertyList[shopNum.select].value }}{{ shopNum.propertyList[shopNum.select].unit }}
                  </span>
                </div>
              </FormItem>
            </div>
            <div
              v-else
            >
              <div class="form-section">
                <span class="form-section-name">{{ item.propertyName }}</span>
              </div>
              <div class="sku-section">
                <div
                  v-for="(sitem,sindex) in item.propertyList"
                  :key="sindex"
                  :class="['sku-item',{select:sindex===item.select}]"
                  @click="skuSelect(index,sindex)"
                >
                  <div class="sku-item-value">
                    {{ sitem.value }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="detail.productKind===2">
            <div class="form-section">
              <div class="form-section-name">
                订购方式
              </div>
              <div style="margin-bottom:14px">
                该产品为组合型产品，如已订购可组合使用的产品，可选择将当前产品与已订购的产品组合，组合后可使用相同的账号、角色、权限使用产品。
              </div>
              <div class="sku-section">
                <div
                  :class="['sku-item',{select:form.params.orderingOption===1}]"
                  @click="selectOrderingOption(1)"
                >
                  <span class="sku-item-radio"></span>
                  <div class="sku-item-value">
                    单独订购及使用
                  </div>
                </div>
                <div
                  :class="['sku-item',{select:form.params.orderingOption===2}]"
                  @click="selectOrderingOption(2)"
                >
                  <span class="sku-item-radio"></span>
                  <div class="sku-item-value">
                    选择已订购产品组合使用
                  </div>
                  <FormItem
                    prop="tenantId"
                    :rules="form.rules.tenantId"
                    style="width: 200px;margin-bottom:0;margin-left:10px"
                  >
                    <Select
                      v-model="form.params.tenantId"
                      transfer
                      placeholder="请选择产品"
                    >
                      <Option
                        v-for="(item) in tenantList"
                        :key="item.value"
                        :value="item.value"
                      >
                        {{ item.label }}
                      </Option>
                    </Select>
                  </FormItem>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="right-form"
          :style="{'minHeight': contentheight}"
        >
          <div class="form-section">
            <span
              class="form-section-name"
              style="margin-bottom: 20px;"
            >订购服务明细</span>
            <Table
              :columns="priceDetail.columns"
              :data="priceDetailData"
              class="price-detail-table"
            ></Table>
          </div>


          <div class="form-footer">
            <div class="coupons-section">
              <Collapse
                v-model="coupons.collapse"
                simple
                class="coupons-collapse"
              >
                <Panel
                  name="1"
                  hide-arrow
                >
                  <div class="coupons-section-name">
                    优惠码
                    <span :class="['arrow',{rotate:coupons.collapse==1}]">
                      <Icon
                        size="20"
                        type="md-arrow-dropdown"
                        color="#999"
                      />
                    </span>
                  </div>
                  <div
                    slot="content"
                    class="coupons-content"
                  >
                    <div class="coupons-box">
                      <Input
                        v-model="coupons.couponCode"
                        class="input-coupons"
                        placeholder="请输入优惠码"
                        clearable
                        @input="coupons.on.input"
                        @on-clear="coupons.on.clear"
                      ></Input>
                      <Button
                        class="coupons-query"
                        type="text"
                        :loading="coupons.loading"
                        @click="coupons.on.couponsQuery"
                      >
                        查询
                      </Button>
                      <div
                        v-if="coupons.couponsPrice"
                        class="coupons-price"
                      >
                        已优惠：-￥{{ coupons.couponsPrice|moneyFix }}
                      </div>
                      <div
                        v-if="coupons.errorMessage"
                        class="error-coupons"
                      >
                        {{ coupons.errorMessage||'无效优惠码' }}
                      </div>
                    </div>
                  </div>
                </Panel>
              </Collapse>
            </div>


            <FormItem
              prop="policy"
              :rules="form.rules.policy"
            >
              <Checkbox v-model="form.params.policy">
                <span class="policy-text">
                  提交订单代表你已阅读并同意
                  <a
                    class="policy-a"
                    :href="skuInfo.buyProtocol"
                    download="智游宝订购协议"
                    target="_blank"
                  >智游宝订购协议</a>
                </span>
              </Checkbox>
            </FormItem>
            <div class="pay-footer">
              <div class="total-section">
                <div class="total-content">
                  <span class="total-text">付款金额：</span>
                  <span class="total-unit">￥</span>
                  <span class="total-price">{{ totalPrice|moneyFix }}</span>
                </div>
                <div
                  v-if="coupons.couponsPrice"
                  class="couponsPrice"
                >
                  已优惠：-￥{{ coupons.couponsPrice|moneyFix }}
                </div>
              </div>
              <Button
                type="primary"
                class="pay-btn"
                :disabled="!skuInfo.saleName"
                :loading="form.loading"
                @click="form.on.submit"
              >
                提交订单
              </Button>
            </div>
          </div>
        </div>
      </Form>
    </div>
    <!--是否已经存在有待付款的订单弹框提示  -->
    <Modal
      v-model="orderModal.visiable"
      title="温馨提示"
      :footer-hide="true"
      :closable="false"
      :width="400"
    >
      <div style="padding: 10px 20px;">
        {{ orderModal.message }}
      </div>
      <div style="text-align: center; margin: 30px 0 20px;">
        <div v-if="orderModal.checkRes.hasTransferPay">
          <Button
            type="primary"
            @click="orderModal.on.goOrderDetail"
          >
            前往取消订单
          </Button>
        </div>
        <div v-else-if="orderModal.checkRes.hasWaitPay">
          <Button

            style="margin-right: 30px;"
            :loading="orderModal.loading"
            @click="orderModal.on.reCreateOrder"
          >
            重新订购
          </Button>
          <Button
            type="primary"
            @click="orderModal.on.goOrderDetail"
          >
            前往支付
          </Button>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  components: {},
  data(){
    return {
      orderType: 1,// 下单类型
      // 订购规格信息
      orderedSku: {},
      // form表单
      form: {
        loading: false,
        params: {
          shopNum: '',
        },
        rules: {
          shopNum: [
            {
              required: false,
              validator: (rule, value, callback) => {
                if (value && !(/^\+?[1-9][0-9]*$/.test(value))) {
                  callback(new Error('数据格式不正确,请输入大于0的整数！'));
                } else {
                  callback();
                }
              },
              trigger: 'blur',
            },
          ],
          policy: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error('请勾选同意协议！'));
                } else {
                  callback();
                }
              },
              trigger: 'change',
            },
          ],
          tenantId: [
            {
              required: true,
              validator: (rule, value, callback) => {
                const {orderingOption} = this.form.params;
                if (orderingOption===2&&!value) {
                  callback(new Error('请选择产品'));
                } else {
                  callback();
                }
              },
              trigger: 'change',
            },
          ],
        },
        on: {
          createOrder: async()=>{
            const {productCode,accountNo} = this.$route.query;
            const {couponCode} = this.coupons;
            const {shopNum,orderingOption,tenantId} = this.form.params;
            let {productSkuId} = this.skuInfo;
            if (this.selectSkuItem.skuId){
              productSkuId = this.selectSkuItem.skuId;
            }
            const {corpCode,corpName} = this.$store.state.user.userInfo;


            // const url = '/paycenter-charge/api/facade/order/create';
            const url = '/paycenter-charge/api/worktable/order/create';
            const params = {
              corpCode,
              corpName,
              // accountNo,
              productCode,
              couponCode,
              productSkuId,
              shopNum,
              // orderType,
            };

            // 获取下单类型
            params.orderType = this.getOrderType();
            // 如果是续费或者升级
            if (accountNo){
              params.accountNo = accountNo;
            }
            if (this.detail.productKind===2){
              // 当前产品为组合型产品时 选择订购方式
              params.orderingOption=orderingOption;
              params.tenantId=tenantId;
            }
            const res = await this.$http.post(url,params);
            if (res.success) {
              this.pay({
                orderNo: res.data.orderNo,
                // accountNo,
              });
              // this.$router.push({
              //   path: '/pay/index',
              //   query: {
              //     orderNo: res.data.orderNo,
              //   },
              // });
            } else {
              this.$Message.warning(res.message || '获取详情失败');
            }

          },
          submit: ()=>{
            // 检查是否认证
            const {corpList,token} = this.$store.state.user.userInfo;
            if (token && (!corpList||!corpList.length)){
              // 弹出去认证弹框
              this.$root.$emit('show-auth-modal');
              return;
            }
            this.$refs.form.validate(async (valid) => {
              if (valid) {
                // 去支付
                // 如果相同的saas产品或相同的应用，已经存在有待付款的订单 在<去支付> 时
                // 提示 “你有服务订单尚未完成支付，请前往支付或重新订购”
                // 前置条件：同一主体、相同产品或应用下
                const checkRes = await this.orderModal.on.check();
                if (checkRes){
                  this.form.loading = true;
                  await this.form.on.createOrder();
                  setTimeout(()=>{this.form.loading = false;},300);
                }
              }
            });
          },

        },
      },
      orderModal: {
        loading: false,
        visiable: false,
        checkRes: {},
        message: '',
        on: {
          show: (message)=>{
            this.orderModal.message = message;
            this.orderModal.visiable = true;
          },
          // 相同的saas产品或相同的应用，是否已经存在有待付款的订单
          check: async()=>{
            const {
              // corpCode,
              // corpName,
              productCode,
              accountNo,
            } = this.$route.query;
            const {corpCode} = this.$store.state.user.userInfo;
            // 下单校验
            const url = '/paycenter-charge/api/worktable/order/create/check';
            const params = {
              productCode,corpCode,
            };
            // 如果是续费或者升级
            if (accountNo){
              params.accountNo = accountNo;
            }
            const res = await this.$http.get(url,params);
            if (res.success){
              this.orderModal.checkRes = res.data;
              const {hasWaitPay,hasTransferPay} = res.data;
              if (hasTransferPay){
                this.orderModal.on.show('你有转账汇款服务订单尚未审核，请先取消订单');

                return false;
              }
              if (hasWaitPay){
                this.orderModal.on.show('你有服务订单尚未完成支付，请前往支付或重新订购');
                return false;
              }
              return true;
            } else {
              this.$Message.warning(res.message||'接口请求失败');
            }
          },
          goOrderDetail: ()=>{
            this.$router.push({
              path: '/app/orderRecord/Detail',
              query: {
                orderNo: this.orderModal.checkRes.orderNo,
              },
            });
          },
          reCreateOrder: async()=>{
            this.orderModal.loading = true;
            await this.form.on.createOrder();
            setTimeout(()=>{this.orderModal.loading = false;},300);
          },
        },
      },
      detail: {},
      // 优惠码
      coupons: {
        collapse: '',
        couponCode: '',
        couponsPrice: '',
        errorMessage: '',
        loading: false,
        on: {
          couponsQuery: ()=>{
            const {couponCode} = this.coupons;
            if (!couponCode){
              this.$Message.warning('请先输入优惠码');
              return;
            }
            // const url = '/paycenter-charge/api/facade/order/coupon';
            const url = '/paycenter-charge/api/worktable/order/coupon';
            const params = {
              couponCode,
            };
            this.coupons.loading = true;
            this.$http.post(url,params).then(res => {
              setTimeout(()=>{this.coupons.loading = false;},300);

              if (res.success) {
                this.coupons.couponsPrice = res.data;
                this.coupons.errorMessage = '';
              } else {
                this.coupons.couponsPrice = '';
                this.coupons.errorMessage = res.message || '无效优惠码';
                // this.$Message.warning(res.message || '优惠码查询失败');
              }
            });
            // if (this.coupons.couponCode=='123456'){
            //   this.coupons.couponsPrice = 100;
            //   this.coupons.noCouponsPrice = false;
            // } else {
            //   this.coupons.couponsPrice = '';
            //   this.coupons.noCouponsPrice = true;
            // }
          },
          clear: ()=>{
            this.coupons.couponsPrice = '';
            this.coupons.errorMessage = '';
          },
          input: (value)=>{
            if (value===''){
              this.coupons.couponsPrice = '';
              this.coupons.errorMessage = '';
            }

          },
        },
      },
      // 费用明细弹框
      priceDetail: {
        visiable: false,
        columns: [
          // {
          //   title: '订购服务',
          //   key: 'version',
          // },
          // {
          //   title: '服务周期',
          //   key: 'period',
          // },
          // {
          //   title: '价格',
          //   key: 'price',
          // },
        ],
        data: [

        ],
      },
      // 规格信息
      skuInfo: {
        productPropertyList: [],
      },
      // 查找匹配的规格
      selectSkuItem: {
        propertyValues: {},
      },
      // 每个版本对应的服务周期的价格
      versionPriceObj: {},
      // 店铺数量
      shopNum: {
        select: 0,
        propertyList: [],
      },
      versionShopNum: 0,
      // 商品规格价格
      // skuPrice: {},
      // 最小高度
      contentheight: '',
      tenantList: [],// 获取组合型产品关联的租户列表
    };
  },
  computed: {
    totalPrice(){
      // 总价格
      let totalPrice = '';
      // 如果没有规格时
      if (!this.skuInfo.skuItemList||!this.skuInfo.skuItemList.length){
        return this.skuInfo.salePrice;
      }
      // 选中的规格价格
      const {salePrice} = this.selectSkuItem;
      // 门店数量价格合计
      const {shopNum} = this.form.params;
      const shopNumItem = this.shopNum.propertyList[this.shopNum.select];
      let storNumPriceTotal = '';
      if (shopNum && shopNumItem){
        const shopPrice = Number(shopNumItem.value||0);
        storNumPriceTotal = Number(shopPrice*shopNum) || 0;
      }

      // 优惠价格
      const {couponsPrice} = this.coupons;

      totalPrice =Number(salePrice||0)+Number(storNumPriceTotal||0)-Number(couponsPrice||0);
      if (totalPrice<=0){
        totalPrice = 0;
      }
      return totalPrice;
    },
    priceDetailData(){
      const {propertyValues,salePrice} = this.selectSkuItem;
      const priceDetailData = [
        {
          // version: title,
          // period: serviceCycleItem.period,
          // price: serviceCycleItem.price,
          ...propertyValues,
          salePrice,
        },
      ];
      const shopNumItem = this.shopNum.propertyList[this.shopNum.select]||{};
      const shopPrice = Number(shopNumItem.value||0);
      // 赠送的店铺
      const {versionShopNum} = this;
      if (versionShopNum){
        priceDetailData.push({
          ...propertyValues,
          type: 'versionShopNum',
          [this.priceDetail.columns[0].key]: `${versionShopNum}个店铺`,
          salePrice: Number(shopPrice*versionShopNum) || 0,
        });
      }
      const {shopNum} = this.form.params;

      // 购买的店铺
      if (shopNum){
        priceDetailData.push({
          ...propertyValues,
          [this.priceDetail.columns[0].key]: `${shopNum}个店铺`,
          // period: serviceCycleItem.period,
          salePrice: Number(shopPrice*shopNum) || 0,
        });
      }
      return priceDetailData;
    },
  },
  async created(){
    // 如果是续费或升级
    const {buyRecordId} = this.$route.query;
    if (buyRecordId){
      await this.getOrderedSku(buyRecordId);
    }
    // 获取规格
    this.getSkuInfo();
    // 获取产品详情
    this.getDetail();

  },
  mounted(){
    this.contentheight = `${window.innerHeight - 120 }px`;
  },
  methods: {
    // 获取已经订购的规格信息
    async getOrderedSku(buyRecordId) {
      const url = '/paycenter-charge/api/worktable/ordered/sku';
      const params = {
        buyRecordId,
      };
      const res = await this.$http.get(url,params);
      if (res.success) {
        this.orderedSku = res.data;
        // 获取下单类型
        this.getOrderType();
      } else {
        this.$Message.warning(res.message || '获取已经订购的规格信息失败');
      }
    },
    // 获取规格
    getSkuInfo() {
      // const url = '/paycenter-charge/api/facade/product/skuInfo';
      const url = '/paycenter-charge/api/worktable/skuInfo';
      const params = {
        productCode: this.$route.query.productCode,
      };
      this.$http.get(url,params).then(res => {
        if (res.success) {
          let {productPropertyList=[]} = res.data;
          // 获取店铺数量
          if (productPropertyList && productPropertyList.length){
            productPropertyList.forEach(ele=>{
              ele.select = 0;
              // 原始值，规格过滤用
              ele.orignPropertyList = [...ele.propertyList];
              if (ele.propertyName==='店铺数量'){
                this.shopNum = ele;
              } else if (ele.propertyName==='服务周期'){
                // 服务周期和店铺数量是一一对应的，过滤规格之后服务周期的数组长度可能会改变
                // 添加服务周期原始索引，用于过滤规格之后通过该原始索引找到对应的店铺数量
                ele.propertyList.forEach((item,index)=>{
                  item.shopNumIndex = index;
                });
              } else if (ele.propertyName==='版本'){
                const {versionName} = this.$route.query;
                if (versionName){
                  ele.select = ele.propertyList.findIndex(item=>item.value===versionName);
                }
                if (ele.select<0){
                  ele.select = 0;
                }
                this.versionShopNum = ele.propertyList[ele.select].shopNum;
                if (this.orderedSku.versionLevel){
                  // 升级暂时未上 先只保留续费功能 后面会去除
                  ele.propertyList = ele.propertyList.filter(item=>item.versionLevel===this.orderedSku.versionLevel);
                }
              }

            });
          } else {
            productPropertyList = [];
          }
          this.skuInfo = {
            ...res.data,
            productPropertyList,
          };
          // 如果是续费升级，设置选中的项
          const {buyRecordId} = this.$route.query;
          if (buyRecordId){
            this.setPropertyListSelect();
          } else {
            // 设置初始选择的值
            this.setHidePropertyList(-1);
          }
          // 商品规格价格计算
          this.getSkuPrice();


        } else {
          this.$Message.warning(res.message || '获取详情失败');
        }
      });
    },
    // 去兑换
    goExchange(){
      const {corpList,token} = this.$store.state.user.userInfo;
      if (token && (!corpList||!corpList.length)){
        // 弹出去认证弹框
        this.$root.$emit('show-auth-modal');
        return;
      }
      const {productCode} = this.$route.query;
      const {href} = this.$router.resolve({
        path: '/standardProduct/exchange/index',
        query: {
          productCode,
          from: 'standardProductOrder',
          // corpCode,
          // corpName,
        },
      });
      // window.open(href,'_blank');
      window.location.href = href;
    },
    // 规格选择
    skuSelect(index,sindex){
      const item = this.skuInfo.productPropertyList[index];
      this.$set(item,'select',sindex);
      if (item.propertyName==='服务周期'){
        // 如果有服务周期和店铺数量，服务周期和店铺数量是一一对应的
        // 根据服务周期自动选择选中的店铺数量
        const serverSelectItem = item.propertyList[sindex];
        this.$set(this.shopNum,'select',serverSelectItem.shopNumIndex);
      }
      if (item.propertyName === '版本'){
        this.versionShopNum = item.propertyList[sindex].shopNum;

        // 获取下单类型
        this.getOrderType();
      }

      // 规格明细中隐藏（needShow===0）的规格不显示
      this.setHidePropertyList(index,sindex);

      // 如果规格全部选择了，则计算价格
      this.getSkuPrice();
    },
    // 获取下单类型
    getOrderType(){
      //orderType 1首次开通 3续费 5版本升级
      let type = 1;
      const {buyRecordId} = this.$route.query;
      if (buyRecordId){
        type = 3;
        // 获取当前选中的版本
        const {productPropertyList} = this.skuInfo;
        const versionProperty = productPropertyList.find(ele=>ele.propertyName==='版本');
        if (versionProperty){
          const versionSelect = versionProperty.propertyList[versionProperty.select];
          if (versionSelect){
            if (this.orderedSku.versionLevel<versionSelect.versionLevel){
              type = 5;
            }
          }
        }



      }
      this.orderType = type;
      return type;

    },
    // 查找匹配的规格
    getSkuPrice(){
      const propertyObj = {};
      const {productPropertyList,skuItemList} = this.skuInfo;
      const columns = [];
      if (productPropertyList && productPropertyList.length){
        productPropertyList.forEach((ele) => {
          const {propertyName,propertyList,select} = ele;
          // propertyObj[`${propertyName}`] = propertyList[select].value+(propertyList[select].unit||'');
          if (propertyName!=='店铺数量'){
            propertyObj[propertyName] = propertyList[select].value+(propertyList[select].unit||'');
            columns.push({
              title: propertyName==='版本'?'订购服务':propertyName,
              key: propertyName,
            });
          }
        });
      }
      if (columns[0]){
        columns[0].render = (h,params)=>{
          const html = [];
          html.push(h('span',params.row[params.column.key]));
          const {type} = params.row;
          // 赠送的店铺数量需要特殊处理
          if (type==='versionShopNum'){
            html.push(
              h(
                'span',
                {
                  style: {
                    color: '#fff',
                    backgroundColor: '#ff9900',
                    display: 'inline-block',
                    marginLeft: '3px',
                    borderRadius: '3px',
                    padding: '2px 5px',
                    fontSize: '12px',
                  },
                },
                '赠送',
              ),
            );
          }

          return html;
        };
      }
      // 费用明细栏目
      columns.push({
        title: '价格',
        key: 'salePrice',
        render: (h,params)=>{
          const {salePrice} = params.row;
          const {type} = params.row;
          let style = {};
          if (type==='versionShopNum'){
            style = {
              textDecoration: 'line-through',
            };
          }
          return h('span',{
            style,
          },`￥${this.$options.filters.moneyFix(salePrice)}`);
        },
      });
      this.priceDetail.columns = columns;

      // 每个版本对应的服务周期的价格
      const versionPriceObj = {};
      if (skuItemList && skuItemList.length){
        skuItemList.forEach(ele=>{
          const propertyValues = JSON.parse(ele.propertyValues);
          let isFind = true;
          Object.keys(propertyObj).forEach(key=>{
            if (propertyObj[key]!==propertyValues[key]){
              isFind = false;
            }
          });
          // 查找匹配的规格
          if (isFind){
            this.selectSkuItem = {
              ...ele,
              propertyValues,
            };
          }
          // 如果服务周期和版本存在 查找版本下每个服务周期的价格
          const versionName =propertyValues['版本'];
          const serverTimeName = propertyValues['服务周期'];
          if (versionName && serverTimeName){
            if (versionPriceObj[versionName]){
              versionPriceObj[versionName][serverTimeName]={
                salePrice: ele.salePrice,
                economizeAmount: ele.economizeAmount,
              };
              // versionPriceObj[versionName].costPrice='';
            } else {
              versionPriceObj[versionName]={
                [serverTimeName]: {
                  salePrice: ele.salePrice,
                  economizeAmount: ele.economizeAmount,
                },

              };
            }
          } else if (serverTimeName){
            versionPriceObj[serverTimeName]=ele.salePrice;
          }
        });

      }
      this.versionPriceObj = versionPriceObj;
    },
    // 规格明细中隐藏（needShow===0）的规格不显示
    setHidePropertyList(index){
      const totalLength = this.skuInfo.productPropertyList.length;
      if (index>=totalLength){
        return;
      }

      // 获取已经选中的规格
      const hasSelectPropertyValues = {};
      let i=0;
      while (i<=index){
        const item = this.skuInfo.productPropertyList[i];
        if (item.propertyName!=='店铺数量'){
          const propertyItem = item.propertyList[item.select];
          hasSelectPropertyValues[item.propertyName] = `${propertyItem.value}${propertyItem.unit||''}`;
        }
        i++;
      }
      // 设置初始选择的值时 index=-1
      let k = totalLength-index;
      if (index<0){
        k = totalLength;
      }
      let j = index+1;
      while (j<k){
        const item = this.skuInfo.productPropertyList[j];
        if (item.propertyName!=='版本'){
          item.select = 0;
        }

        // const propertyItem = item.propertyList[sindex];
        if (item.propertyName!=='店铺数量'){
          item.propertyList = item.orignPropertyList.filter(ele=>{
          // 查找选择的规格是否显示
            const propertyValuesItem = {
              ...hasSelectPropertyValues,
            };
            propertyValuesItem[item.propertyName] = `${ele.value}${ele.unit||''}`;
            let isShow = false;
            this.skuInfo.skuItemList.find(skuItem=>{
              if (skuItem.needShow===1){
                const propertyValues = JSON.parse(skuItem.propertyValues);
                let isFind = true;
                Object.keys(propertyValuesItem).forEach(key=>{
                  if (propertyValuesItem[key]!==propertyValues[key] ){
                    isFind = false;
                  }
                });
                if (isFind){
                  isShow = true;
                }
              }
              return isShow;
            });

            return isShow;
          });
          const propertyItem = item.propertyList[item.select];
          // 添加选中的项
          hasSelectPropertyValues[item.propertyName] = `${propertyItem.value}${propertyItem.unit||''}`;
        }
        j++;
      }

      // let index
      // while(){

      // }
    },
    // 如果是续费升级，设置选中的项
    setPropertyListSelect(){
      const {propertyArray,totalShopNum,versionLevel} = this.orderedSku;
      const propertyObj = JSON.parse(propertyArray);

      // 设置选中的项
      this.skuInfo.productPropertyList.forEach(ele=>{
        const {propertyName} = ele;
        // 选中的值的
        const selectValue = propertyObj[propertyName];
        if (selectValue){
          let {propertyList} = ele;

          if (propertyName==='版本'){
            // 比当前已订购的版本的版本等级低的版本，页面需要隐藏不显示
            propertyList = propertyList.filter(sele=>sele.versionLevel>=versionLevel);
            ele.propertyList = propertyList;
          }
          ele.select = propertyList.findIndex(item=>{
            let value = item.value.trim();
            if (item.unit){
              value+=item.unit;
            }
            return value===selectValue.trim();
          });
          if (propertyName==='版本'){

            // 获取当前版本已包含店铺的数量
            this.versionShopNum = propertyList[ele.select].shopNum;
            // 门店数量
            const shopNum = totalShopNum-this.versionShopNum;
            if (shopNum>0){
              this.form.params.shopNum = shopNum;
            } else {
              this.form.params.shopNum = '';
            }
          }
        }
      });
      // // 如果有门店数量
      // if (this.versionShopNum){
      //   const shopNum = totalShopNum-this.versionShopNum;
      //   if (shopNum){
      //     this.form.params.shopNum = shopNum;
      //   }

      // }
    },
    // 获取组合型产品关联的租户列表
    async getListRefTenantByProductId(){
      const url = '/paycenter-charge/api/worktable/listRefTenantByProduct';
      const {corpCode} = this.$store.state.user.userInfo;
      // const {productId} = this.$route.query;
      const params = {
        productCode: this.$route.query.productCode,
        corpCode,
      };
      const res = await this.$http.get(url,params);
      if (!res.success) {
        this.$Message.warning(res.message || '获取组合型产品关联的租户列表失败');
      }
      this.tenantList = res.data.map(({accountName: label,tenantId: value})=>{
        return {
          label,
          value,
        };
      });

    },
    // 获取详情
    getDetail() {
      const {corpCode} = this.$store.state.user.userInfo;
      const url = '/paycenter-charge/api/facade/product/view';
      const params = {
        productCode: this.$route.query.productCode,
        corpCode,
      };
      this.$http.get(url,params).then(res => {
        if (res.success) {
          this.detail = res.data;
          if (this.detail.productKind===2){
            // 当前产品为组合型产品时 选择订购方式
            this.getListRefTenantByProductId();
          }
        } else {
          this.$Message.warning(res.message || '获取详情失败');
        }
      });
    },
    selectOrderingOption(orderingOption){
      this.$set(this.form.params,'orderingOption',orderingOption);
    },
  },
};
</script>
<style lang="less" scoped>
@selectColor: #4772fc;
@errorColor: #f05334;
.breadcrumb-box {
  // background-color: #fff;
  padding-bottom: 10px;
  position: relative;
  .go-back {
    position: absolute;
    right: 20px;
    top: 20px;
  }
}
.page-content {
  // background-color: #fff;
}
.steps-box {
  padding-top: 30px;
  width: 600px;
  margin: 0  auto 80px;
}
.form-box {
  width: 1200px;
  margin: 0 auto;
  display: flex;
}
.form-section {
  margin-bottom: 14px;
  .form-section-name {
    color: #333;
    font-weight: bold;
    font-size: 20px;
    margin-right: 10px;
    display: inline-block;
  }
  .form-section-tip {
    color: #999;
    font-size: 12px;
    // padding-left: 20px;
    margin-top: 15px;
  }
  .exhcnge-btn {
    font-size: 12px;
    color: #409eff;
    padding: 0;
    cursor: pointer;
  }
}
.version-item {
  font-size: 16px;
  color: #666;
  // font-weight: bold;
  border: 1px solid #e0e0e0;
  padding: 26px 30px 26px 40px;
  border-radius: 5px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
    height: 68px;

  &.select {
    border: 1px solid @selectColor;
  }
  .version-name {
    display: inline-block;
    // width: 100px;
    font-size: 18px;
  }
  .version-type {
    font-size: 12px;
    margin-left: 9px;
    .version-type-text {
      display: inline-block;
      width: 34px;
      height: 18px;
      line-height: 18px;
      border-radius: 0 2px 0 4px;
      text-align: center;
      &1 {
        color: #4772fc;
        border: 1px solid #4772fc;
      }
      &2 {
        color: @errorColor;
        border: 1px solid @errorColor;
      }
    }
  }
  img {
    margin-left: auto;
    height: 28px;
  }
}
.sku-section {
  margin-bottom: 30px;
  .sku-item {
    color: #666;
    border: 1px solid #ebebeb;
    border-radius: 4px;
    margin-right: 10px;
    text-align: center;
    position: relative;
    display: flex;
    align-items: center;
    height: 68px;
    box-sizing: border-box;
    padding: 26px 30px 26px 40px;
    margin-bottom: 20px;
    .sku-item-radio{
      width: 16px;
      height: 16px;
      border: 1px solid #666;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      &::before{
        content: "";
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: @selectColor;
        display: none;
      }
    }
    .sku-item-value {
      font-size: 18px;
      color: #333;
      margin-left: 8px;
    }
    .sku-item-price {
      font-size: 14px;
      color: #666;
      margin-left: 20px;
    }
    .economize-amount {
      color: #1faa63;
      margin-left: auto;
    }
    &.select {
      border: 1px solid @selectColor;
      .sku-item-radio{
        border: 1px solid @selectColor;
        &::before{
          display: block;
        }
      }
      .ivu-icon-ios-radio-button-on {
        color: @selectColor;
      }
    }
  }
}
.shopNum-box {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 15px 30px 15px 40px;
  /deep/ .ivu-input {
    border: 0;
    outline: 0;
    font-size: 14px;
    font-weight: bold;
    &::placeholder {
      font-weight: normal;
    }
    &:focus {
      box-shadow: 0 0;
    }
  }
  .input-shopNum {
    width: 66%;
    border: 0;
    outline: 0;
  }
  .shopNum-unit {
    // width: 20%;
    // text-align: center;
    padding-left: 10px;
    font-size: 14px;
    float: right;
  }
}
.coupons-section {
  margin-bottom: 20px;
  /deep/ .ivu-collapse-header {
    width: 100px;
  }
  /deep/.ivu-collapse-content-box {
    padding-bottom: 0;
  }
  .coupons-collapse {
    height: 82px;
  }
  .coupons-section-name {
    color: #333;
    font-weight: bold;
    font-size: 16px;
    margin-left: -16px;
  }
  .coupons-content {
    margin-left: -16px;
    white-space: nowrap;
  }
  .ivu-collapse-simple {
    border: 0;
  }
  .arrow {
    transition: all 300ms ease;
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    &.rotate {
      transform: rotate(180deg);
    }
  }
  .input-coupons {
    box-sizing: border-box;
    width: 80%;
    outline: 0;
    box-sizing: border-box;
    border: 1px solid #c4c6cf;
    border-radius: 2px;
    padding: 0 1px;
    margin-right: 10px;
    /deep/ .ivu-input {
      border: 0;
      outline: 0;
      font-size: 14px;
      font-weight: bold;
      height: 30px;
      &:focus {
        box-shadow: 0 0;
      }
      &::placeholder {
        font-weight: normal;
      }
    }
  }
  .coupons-query {
    color: #4772fc;
    border: 1px solid #4772fc;
    outline: 0;
    text-align: center;
    padding: 6px 20px;
    border-radius: 2px;
    height: unset;
  }
  .coupons-price {
    font-size: 12px;
    color: @errorColor;
    padding-top: 5px;
  }
  .error-coupons {
    color: @errorColor;
    font-size: 12px;
    padding-top: 5px;
  }
}
.total-section {
  .couponsPrice {
    font-size: 14px;
    color: @errorColor;
  }
  .total-content {
    color: #333;
  }
  .total-unit {
    font-size: 18px;
  }
  .total-price {
    font-size: 26px;
    font-weight: bold;
  }
  .total-detail {
    font-size: 12px;
    color: #409eff;
    cursor: pointer;
  }
}
.price-detail-modal {
  .price-detail-footer {
    text-align: center;
  }
  .detail-total {
    text-align: right;
  }
}
.policy-text {
  font-size: 14px;
  color: #999;
  .policy-a {
    color: @selectColor;
  }
}
.left-form {
  width: 660px;
  background-color: #fff;
  margin-right: 20px;
  box-sizing: border-box;
  padding: 36px 70px;
}
.right-form {
  width: 520px;
  background-color: #fff;
  box-sizing: border-box;
  padding: 36px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .pay-footer {
    display: flex;
    justify-content: space-between;
    padding-top: 34px;
    border-top: 1px solid #eee;
    .pay-btn {
      width: 178px;
      height: 62px;
      line-height: 62px;
      text-align: center;
      border-radius: 2px;
      font-size: 22px;
      color: #fff;
    }
  }
}
/deep/.price-detail-table{
  .ivu-table-header thead tr th{
    background-color: #fff;
    border-bottom: 1px solid #e8eaec;
    padding: 12px 0;
  }
  .ivu-table:before{
    content: none;
  }
  .ivu-table-tbody .ivu-table-row td{
    border-bottom: none;
  }
}
</style>
